<template>
    <div>
        <h2>集計済サーベイ一覧</h2>
        <v-spacer></v-spacer>
        <v-data-table :headers="headers" :items="surveys" hide-actions class="elevation-1">
            <template slot="items" slot-scope="props">
                <tr @click="toResult(props.item)">
                    <td class="text-xs-left">{{ getFormatDate(props.item.end_date) }}</td>
                    <td class="text-xs-left">{{ props.item.name }}</td>
                </tr>
            </template>
        </v-data-table>

    </div>
</template>

<script>

import db from '@/components/firebaseInit'
import { unixtimeToFormattedDate} from "@/utils/datetime.js"
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
    data() {
        return {
            user_query: "",
            surveys: [],
            headers: [
                {
                    text: '実施日',
                    align: 'left',
                    sortable: false,
                    value: 'end'
                },
                {
                    text: 'サーベイ名',
                    align: 'left',
                    sortable: false,
                    value: 'name'
                },
            ],
        }

    },
    computed: {
    ...mapGetters("auth", ["isLoggedIn", "user"])
    },
    mounted() {
        this.user_query="subjects."+this.user.uid
        this.updateSurveys()
        console.log(this.user)
        
    },
    methods: {
        toResult(s) {
            
            this.$router.push({ name: "result", params: { company_id: this.$route.params.company_id, survey_id: s.id, user_id: this.user.uid } })
        },
        async updateSurveys() {
            this.surveys = []
            console.log(this.surveys)
            const surveys = await db.collection("companies").doc(this.$route.params.company_id).collection("surveys").where(this.user_query, "==", true).get()
            surveys.forEach((doc) => {
                this.surveys.push({ id: doc.id, ...doc.data() })
            })
        },
        getFormatDate(ut){
            return unixtimeToFormattedDate(ut)
        }
    },
    created: function () {
    }

}
</script>
<style lang="scss" scoped>
</style>